module.exports = __webpack_public_path__ + "static/media/4piechart.62fcfae1.png";